export enum ItemTypes {
  Header,
  ListItem,
}

export const ITEM_SIZES_BY_TYPE = {
  [ItemTypes.Header]: 24,
  [ItemTypes.ListItem]: 48,
} as const;

export type VirtualizedListItem = {
  type: ItemTypes;
  node: JSX.Element;
};

export type VirtualizedSection = {
  header: JSX.Element;
  items: JSX.Element[];
};
